const APP_TOKEN_NAME = 'token_kb_customer';
const USER_INFO_KEY = 'user_info';
const ALERT_DEFAULT_TIME = 5;
const LANGUAGE_SETTING_APP = 'ja';
const TIMING_LOADER = 500;
const LOCALE_TOOL_TOKYU = 'LOCALE_TOOL_TOKYU';
const DEFAULT_DATE_FORMAT = 'YYYY/MM/DD (ddd)';
const PER_PAGE_LIST = [10, 20, 50, 100];
const HORIZONTAL = 'HOZ';
const ROLE_USER = 1;
const ROLE_ADMIN = 2;
const TYPE_UPLOAD_USER = 'user';
const IMAGE_TEMPLATE = 'https://via.placeholder.com/400x300?text=Image-demo';
const TYPE_TEXT = 'SINGLE_LINE_TEXT';
const TYPE_TEXTS = 'MULTI_LINE_TEXT';
const TYPE_DROPDOWN = 'DROP_DOWN';
const TYPE_RECORD_NUMBER = 'RECORD_NUMBER';
const TYPE_DATE = 'DATE';
const TYPE_TIME = 'TIME';
const TYPE_DATE_TIME = 'DATETIME';
const TYPE_CHECK_BOX = 'CHECK_BOX';
const TYPE_UPDATE_TIME = 'UPDATED_TIME';
const TYPE_CREATED_TIME = 'CREATED_TIME';
const TYPE_CREATOR = 'CREATOR';
const TYPE_MODIFIER = 'MODIFIER';
const TYPE_NUMBER = 'NUMBER';
const TYPE_SUB_TABLE = 'SUBTABLE';
const TYPE_REFERENCE_TABLE = 'REFERENCE_TABLE';
const TYPE_FILE = 'FILE';
const TYPE_RADIO_BUTTON = 'RADIO_BUTTON';
const TYPE_CALC = 'CALC';
const TYPE_RICK_TEXT = 'RICH_TEXT';
const TYPE_MULTI_SELECT = 'MULTI_SELECT';
const TYPE_USER_SELECT = 'USER_SELECT';
const TYPE_GROUP_SELECT = 'GROUP_SELECT';
const TYPE_ORGANIZATION_SELECT = 'ORGANIZATION_SELECT';
const TYPE_LINK = 'LINK';
const TYPE_CONTENT_TEXT = ['USER_SELECT', 'GROUP_SELECT', 'ORGANIZATION_SELECT', 'SINGLE_LINE_TEXT', 'DROP_DOWN', 'RECORD_NUMBER', 'CHECK_BOX', 'CREATOR', 'MODIFIER', 'FILE', 'CALC', 'MULTI_SELECT'];
const TYPE_CONTENT_DATE = ['DATE', 'UPDATED_TIME', 'CREATED_TIME', 'DATETIME'];
const TYPE_SORT = ['RECORD_NUMBER', 'UPDATED_TIME', 'CREATED_TIME', 'SINGLE_LINE_TEXT', 'NUMBER', 'CALC', 'RADIO_BUTTON', 'DROP_DOWN', 'DATE', 'TIME', 'DATE', 'DATETIME', 'LINK'];
const TYPE_SETTING_MEMBER = [
    { value: 'text', label: 'Text' },
    { value: 'number', label: 'Number' },
    { value: 'date', label: 'Date' },
    { value: 'datetime', label: 'DateTime' }
];
const USER_FIELDS = [
    { value: 'surname', label: '姓' },
    { value: 'name', label: '名' },
    { value: 'name_fullsize', label: '姓名（全角スペース）' },
    { value: 'name_halfsize', label: '姓名（半角スペース）' },
    { value: 'fullname', label: '姓名（連続）' },
    { value: 'email', label: 'メールアドレス' },
    { value: 'company_name', label: '会社名' },
    { value: 'address', label: '住所' },
    { value: 'phone_number', label: '電話番号' }
];
const TYPE_USER_LOGIN = [
    { label: '管理者モード', value: 3 },
    { label: '一般モード', value: 4 }
];
const TYPE_PLAN_READONLY = 0;
export {
    LANGUAGE_SETTING_APP,
    APP_TOKEN_NAME,
    TIMING_LOADER,
    ALERT_DEFAULT_TIME,
    PER_PAGE_LIST,
    USER_INFO_KEY,
    DEFAULT_DATE_FORMAT,
    TYPE_UPLOAD_USER,
    IMAGE_TEMPLATE,
    HORIZONTAL,
    ROLE_USER,
    ROLE_ADMIN,
    LOCALE_TOOL_TOKYU,
    TYPE_TEXT,
    TYPE_DROPDOWN,
    TYPE_RECORD_NUMBER,
    TYPE_CHECK_BOX,
    TYPE_CREATOR,
    TYPE_DATE,
    TYPE_MODIFIER,
    TYPE_UPDATE_TIME,
    TYPE_NUMBER,
    TYPE_CREATED_TIME,
    TYPE_CONTENT_DATE,
    TYPE_CONTENT_TEXT,
    TYPE_SUB_TABLE,
    TYPE_TIME,
    TYPE_TEXTS,
    TYPE_FILE,
    TYPE_RADIO_BUTTON,
    TYPE_CALC,
    TYPE_DATE_TIME,
    TYPE_RICK_TEXT,
    TYPE_MULTI_SELECT,
    TYPE_USER_SELECT,
    TYPE_GROUP_SELECT,
    TYPE_ORGANIZATION_SELECT,
    TYPE_LINK,
    TYPE_REFERENCE_TABLE,
    TYPE_SORT,
    TYPE_SETTING_MEMBER,
    USER_FIELDS,
    TYPE_PLAN_READONLY,
    TYPE_USER_LOGIN
};
